import { inject } from 'mobx-react';
import { useHistory, useLocation } from 'react-router';
import * as React from 'react';

import { updateSearch } from 'bernie-core';

import { LoyaltyDiscountToggle } from '@shared-ui/lodging-property-offers';
import { useLocalization } from '@shared-ui/localization-context';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';
import { SearchCriteriaModel } from 'stores/models';

import { Level, liveAnnounce } from 'uitk-react-utils';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

interface LoyaltyDiscountToggleWrapperProps extends SharedUiWrapperProps {
  currentHotel?: CurrentHotelStore;
}

export const getHandleClick =
  (
    searchCriteria: SearchCriteriaModel | undefined,
    history: ReturnType<typeof useHistory>,
    location: ReturnType<typeof useLocation>,
    l10n?: ReturnType<typeof useLocalization>
  ) =>
  () => {
    updateSearch({ history, location, newParams: { useRewards: String(searchCriteria?.useRewards !== 'true') }, replace: true });

    if (searchCriteria?.useRewards === 'true') {
      setTimeout(() => liveAnnounce(l10n?.formatText('common.pointsRemoved'), Level.POLITE), 500);
    } else {
      setTimeout(() => liveAnnounce(l10n?.formatText('common.pointsApplied'), Level.POLITE), 500);
    }
  };

const LoyaltyDiscountToggleWrapper: React.FC<LoyaltyDiscountToggleWrapperProps> = inject('currentHotel')(({ inputs, currentHotel }) => {
  const history = useHistory();
  const location = useLocation();
  const l10n = useLocalization();

  return (
    <LoyaltyDiscountToggle
      inputs={inputs}
      onChange={getHandleClick(currentHotel?.searchCriteria, history, location, l10n)}
      checked={currentHotel?.searchCriteria.useRewards === 'true'}
      skipSsr={false}
    />
  );
});

LoyaltyDiscountToggleWrapper.displayName = 'LoyaltyDiscountToggleWrapper';
export const SharedUiLoyaltyDiscountToggleWrapper = withSharedUiPropertyOffers(LoyaltyDiscountToggleWrapper);
